<template>
    <q-card class="card-product full-height bg-white"
            :bordered="selected" :style="selected ? 'border-color: green; border-bottom-left-radius: 0; border-bottom-right-radius: 0' : ''">

        <div>
            <div class="rounded-borders card-body q-py-xl bg-white" :class="{'q-px-xl' : screenSize.gt.sm, 'q-px-lg' : screenSize.lt.md}">
                <div class="text-h5 text-weight-bold text-primary">{{ product.description }}</div>
                <div class="text-body1">{{ productType }}</div>
                <div class="text-center q-my-md text-black">
                    <div v-if="showPrice">
                        <span class="text-h5 text-primary text-weight-medium q-mx-xs"><small class="vertical-top">$</small>{{ getCurrency(product) }}</span>{{ currency }}<span v-if="product.isSubscription">/year</span>
                    </div>
                </div>
                <div v-if="!(features && features.length > 0)" class="text-body2 q-mt-md">
                    {{ product.webText }}
                </div>
            </div>
        </div>

        <div v-if="selected" class="row justify-center items-center text-weight-medium text-white q-pa-xs bg-positive full-width">
            <q-icon name="mdi-check-bold" size="2.5em" class="float-right" color="white" /> Selected
        </div>
    </q-card>
</template>

<script>
    export default {
        name: 'product',
        props: {
            product: Object,
            selected: {
                default: false,
                type: Boolean
            },
            showPrice: {
                default: true,
                type: Boolean
            },
        },
        methods: {
            getCurrency(product) {
                if (this.cart.currency == 1) return product.listPriceCDN
                else return product.listPriceUS

            },
        },
        computed: {
            cart() { return this.$store.getters.cart },
            currency() {
                if (this.cart.currency == 1) return 'CAD'
                else return 'USD'
            },
            screenSize() {
                return this.$q.screen
            },
            productType() {
                if (this.product.isSubscription) return 'Subsription Renewal'
                if (this.product.isUpgrade) return 'Upgrade'
                return 'Full License'
            }
        }

    }
</script>
